
import CRUD from './CRUD'
import Auth from './Auth'

export default {
  CRUD,
  Auth
}



// WEBPACK FOOTER //
// ./src/components/Logs/index.js